<ng-container *ngIf="profileField$ | async as profileField">
    <dt [id]="profileField.FieldDefinition.DottedKey" class="sh-description-list__term" style="{{ nestedPadding$ | async }}">
        <sh-field-label [label]="profileField.DisplayLabel" [labelIcons]="labelIcons"></sh-field-label>
    </dt>

    <ng-container *ngIf="translatedValue$ | async as translatedValue; else emptyData">
        <ng-container
            *ngTemplateOutlet="
                canSearchOnClick(profileField.FieldDefinition) ? searchableData : nonSearchableData;
                context: { translatedValue: translatedValue, fieldDefinition: profileField.FieldDefinition }
            "
        >
        </ng-container>
    </ng-container>
</ng-container>

<ng-template #searchableData let-translatedValue="translatedValue" let-fieldDefinition="fieldDefinition">
    <dd
        [routerLink]="searchRouterLink"
        [queryParams]="getSearchRouterParams(fieldDefinition, translatedValue.value)"
        class="sh-link sh-description-list__details"
    >
        {{ translatedValue.label }}
    </dd>
</ng-template>

<ng-template #nonSearchableData let-translatedValue="translatedValue">
    <dd class="sh-description-list__details">{{ translatedValue.label }}</dd>
</ng-template>

<ng-template #emptyData>
    <dd class="sh-description-list__details">-</dd>
</ng-template>
